// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1C7uW","footer":"ModalFilter_footer__2MYfi"};